import Config from '@config';
import { initializeMeteringNodeApi } from '@gasbi/shared/common/features/meteringNode';
import { useSelector } from 'react-redux';

import { cachedItemByIdSelector } from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

const meteringNode = initializeMeteringNodeApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  meteringNodeApi,
  useGetMeteringNodesQuery,
  useCreateMeteringNodeMutation,
  useGetMeteringNodeByIdQuery,
  useUpdateMeteringNodeByIdMutation,
  useGetMeteringNodesInfiniteQuery,
} = meteringNode;

const getCachedNodeByIdSelector = cachedItemByIdSelector(
  'meteringNodeApi',
  'getMeteringNodesI',
);

export const useGetCachedNodeByIdSelector = id =>
  useSelector(getCachedNodeByIdSelector(id));
